import { BaseService } from '@/core/base-service';

export default class LaptimeDaysService extends BaseService<any> {
  public constructor() {
    super('api/public/ghmoto/laptime-days');
  }
}
